module.exports = __webpack_public_path__ + "img/2021jy_intro3.a9a33e53.jpg";